import { JsonLogsSerializer } from '@opentelemetry/otlp-transformer'

export type ExportResult = { code: number; error?: Error }
export type ExportCallback = (result: ExportResult) => void

/** OTLP JSON log exporter used by the browser LoggerProvider. */
export class OtelHttpJsonLogExporter {
  private url: string

  constructor(url: string) {
    this.url = url
  }

  export(logRecords: any[], resultCallback: ExportCallback): void {
    try {
      const bodyBytes: Uint8Array | undefined =
        JsonLogsSerializer.serializeRequest(logRecords)
      if (!bodyBytes) {
        resultCallback({
          code: 1,
          error: new Error('otlp_logs_serialize_failed'),
        })
        return
      }
      const body = new TextDecoder().decode(bodyBytes)
      void fetch(this.url, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body,
        keepalive: true,
      })
        .then(res => {
          if (!res.ok) {
            resultCallback({
              code: 1,
              error: new Error(`otlp_logs_http_${res.status}`),
            })
            return
          }
          resultCallback({ code: 0 })
        })
        .catch(err => {
          resultCallback({ code: 1, error: err as Error })
        })
    } catch (err) {
      resultCallback({ code: 1, error: err as Error })
    }
  }

  shutdown(): Promise<void> {
    return Promise.resolve()
  }
}
